module.exports = __webpack_public_path__ + "img/Capricornus.22f880a1.png";